import { render, staticRenderFns } from "./CrossIconNew.vue?vue&type=template&id=533db30c"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('533db30c')) {
      api.createRecord('533db30c', component.options)
    } else {
      api.reload('533db30c', component.options)
    }
    module.hot.accept("./CrossIconNew.vue?vue&type=template&id=533db30c", function () {
      api.rerender('533db30c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/CrossIconNew.vue"
export default component.exports